import { useMemo } from "react"
import { isEmpty, isNil } from "lodash"
import { getValidFilters } from "components/add-filter/helpers"
import { computeUpdatedFilters, mapFactorExposureNegativeBoolOperator } from "helpers/filters"
import { SecuritySearchFilter } from "resources/filters"
import type { Filter } from "resources/filter-ons"

export default function useSecuritySearchFilter(filters: Filter[], universeFilters: Filter[]): SecuritySearchFilter | null {
  return useMemo(() => {
    const validFilters = getValidFilters(filters)
    const validUniverseFilters = universeFilters.filter(filter => filter.filterOn && filter.operator && filter.values.length > 0)
    const newUniverseFilters = validUniverseFilters.map(filter => ({
      ...filter,
      values: filter.values.map(value => {
        if (typeof value === "number" || isNil(value)) return value
        return value?.value
      }),
    }))
    const computedFilters: { filter: SecuritySearchFilter | null } = computeUpdatedFilters(validFilters)
    const computedUniverseFilters: { filter: SecuritySearchFilter | null } = computeUpdatedFilters(newUniverseFilters)
    const combinedFilter = {
      ...computedFilters.filter,
      ...(computedUniverseFilters.filter?.universe && computedUniverseFilters.filter.universe?.length > 0 && { universe: computedUniverseFilters.filter.universe }),
    }
    if (isEmpty(combinedFilter)) {
      return null
    }
    return mapFactorExposureNegativeBoolOperator(combinedFilter)
  }, [filters, universeFilters])
}
